import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { NormalizedCargo } from "../../../../../../domain/models/cargo-model";

type Props = {
  cargo: NormalizedCargo;
  onClick: (id: number) => void;
};

type Status = {
  name: "Não Iniciada" | "Em Andamento" | "Finalizada";
  color: "error" | "success" | "warning";
  button: "Iniciar" | "Continuar" | "Ver";
};

export const CargoCard: React.FC<Props> = ({ onClick, cargo }) => {
  const getStatus = (): Status => {
    let hasSeparated = false;
    let hasNotSeparated = false;
    cargo.cargoItems.forEach((item) => {
      item.inventoryReservations?.forEach((reservation) => {
        if (reservation.status === "NOT_SEPARATED") {
          hasNotSeparated = true;
        }
        if (reservation.status === "SEPARATED") {
          hasSeparated = true;
        }
      });
    });

    if (hasSeparated && hasNotSeparated)
      return { name: "Em Andamento", color: "warning", button: "Continuar" };
    if (hasNotSeparated && !hasSeparated)
      return { name: "Não Iniciada", color: "error", button: "Iniciar" };
    return { name: "Finalizada", color: "success", button: "Ver" };
  };

  return (
    <Paper sx={{ p: "20px" }}>
      <Stack direction="row">
        <Box
          sx={{
            width: "60%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack>
            <Typography>{`Carga: ${cargo.reference}`}</Typography>
            <Typography fontWeight="bold" fontSize="20px">
              {cargo.clientName}
            </Typography>
            <Typography>{`Quantidade de Itens: ${cargo.cargoItems.length}`}</Typography>
          </Stack>
        </Box>
        <Box
          sx={{
            width: "40%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          <Chip
            label={getStatus().name}
            variant="outlined"
            color={getStatus().color}
            size="small"
          />
          <Button
            variant="contained"
            color="secondary"
            sx={{ color: "white" }}
            onClick={onClick.bind(null, 1)}
          >
            {getStatus().button}
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};
